export const sectionLayout = {
    xs: {span: 22, offset: 1},
    sm: {span: 22, offset: 1},
    md: {span: 20, offset: 2},
    lg: {span: 14, offset: 5},
    xl: {span: 14, offset: 5},
}

export const sectionMargin = '4rem'
